import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as content from '../../content'

/** Component for displaying structure types */
@ngCore.Component({
  imports: [
    content.list.Component,
    content.standard.Component,
    content.object.Component,
  ],
  selector: 'atn-structure-switcher',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.common.value.types.Structure} */
  public readonly structureSg =
    ngCore.input.required<ents.core.common.value.types.Structure>({
      alias: 'structure',
    })

  /** Structure value */
  public readonly valueSg = ngCore.input.required<
    ents.core.common.value.Raw | undefined
  >({
    alias: 'value',
  })

  /**
   * Returns value if it's type is
   * {@link ents.core.common.value.types.Intrinsic.List | Intrinsic.List},
   * otherwise returns undefined
   */
  public readonly valueIfListSg = ngCore.computed(
    (value = this.valueSg(), structure = this.structureSg()) =>
      structure.intrinsic === ents.core.common.value.types.Intrinsic.List
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.List,
          )
        : undefined,
  )

  /**
   * Returns value if it's type is
   * {@link ents.core.common.value.types.Intrinsic.Object | Intrinsic.Object},
   * otherwise returns undefined
   */
  public readonly valueIfObjectSg = ngCore.computed(
    (value = this.valueSg(), structure = this.structureSg()) =>
      structure.intrinsic === ents.core.common.value.types.Intrinsic.Object
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.Object,
          )
        : undefined,
  )
}
